webpackJsonp([17445525839734],{

/***/ 385:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ExamplePage = __webpack_require__(6);
	
	var _ExamplePage2 = _interopRequireDefault(_ExamplePage);
	
	var _CodeSample = __webpack_require__(5);
	
	var _CodeSample2 = _interopRequireDefault(_CodeSample);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return _react2.default.createElement(
	    _ExamplePage2.default,
	    { title: 'Using input field with state' },
	    _react2.default.createElement(
	      'p',
	      null,
	      'This example shows how to handle the state in the parent component. Note that disabled days cannot be picked from the overlay, but they may be set in the input field.'
	    ),
	    _react2.default.createElement(_CodeSample2.default, { name: 'examples/input-state' })
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-examples-input-state-js-b2e2756f598c9fbe2c04.js